import { gql } from 'graphql-request'

export const REMOVE_DEVICE = gql`
  mutation RemoveDevice($removeDeviceInput: RemoveDeviceInput!) {
    removeDevice(removeDeviceInput: $removeDeviceInput) {
      message
    }
  }
`
